import React, { Component } from 'react';
import './Photos.css';
import Header from './Header';
import Gallery from './Gallery'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';

class Photos extends Component {
  orientation(id) {
    if ([0, 1, 3, 4, 5, 8, 19, 21, 22, 25, 26, 37, 43, 44].includes(id)) {
      return 'portrait'
    } else {
      return 'landscape'
    }
  }
  image(id) {
    const i = {
      id: id,
      orientation: this.orientation(id),
      useForDemo: true,
      src: `https://s3.amazonaws.com/ah-7c153a8d471d6e3719de452b4880152f/${id}.jpg`,
    }
    return i;
  }
  render() {
    var caption = "Photos of the lovely couple"
    const toolbarStyle = {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    }
    const toolbarGroupStyle = {
        float       : 'none',
        marginLeft  : 'auto',
        marginRight : 'auto',
        textAlign   : 'center',
    };
    const images = [...Array(45).keys()].map(id => this.image(id));
    return (
      <div className="Photos">
        <Header caption={caption} />
        <MuiThemeProvider>
          <Toolbar style={toolbarStyle}>
            <ToolbarGroup style={toolbarGroupStyle}>
              <a className="plain-link back-link" href="/">&lt; Back to Site</a>
            </ToolbarGroup>
          </Toolbar>
        </MuiThemeProvider>
        <div className="photos-section row middle-xs center-xs">
          <div className="col-lg-9 col-xs-12">
            <h2>Alex and Hana&#39;s Engagement Photoshoot</h2>
            <h3>San Francisco, CA</h3>
            <h3>February 20, 2017</h3>
            <Gallery images={images}/>
          </div>
        </div>
      </div>
    );
  }
}

export default Photos;



// WEBPACK FOOTER //
// ./src/Photos.js